import React from "react";
import { ConfirmationModalContainer } from "../Modal/ConfirmationModalContainer";
import { getValue } from "../../utils/object.utils";
interface Props {
  open: boolean;
  onClose: () => unknown;
  handleClassRemove: () => unknown;
  selectedClassToRemove: any;
  isProcessingConfirmation: boolean;
}

export const RemoveClassModal = ({
  open,
  onClose,
  handleClassRemove,
  selectedClassToRemove,
  isProcessingConfirmation,
}: Props) => {
  const className = getValue(selectedClassToRemove, "name", "");
  return (
    <ConfirmationModalContainer
      show={open}
      onClose={onClose}
      onSubmit={handleClassRemove}
      isRemoving
      isProcessingConfirmation={isProcessingConfirmation}
    >
      <div>Do you want to remove class {className} ?</div>
    </ConfirmationModalContainer>
  );
};
